var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    color: "#9FA0A7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.037 4.24126C16.5187 3.88384 17.2023 3.92355 17.6392 4.36041C18.1197 4.84095 18.1197 5.62007 17.6392 6.10061L12.7401 10.9998L17.6396 15.8994C18.1201 16.3799 18.1201 17.159 17.6396 17.6396C17.2027 18.0765 16.5191 18.1162 16.0374 17.7587L15.8994 17.6396L11 12.74L6.10055 17.6396L5.96254 17.7587C5.48083 18.1162 4.79724 18.0765 4.3604 17.6396C3.87987 17.159 3.87987 16.3799 4.3604 15.8994L9.25984 10.9998L4.3608 6.10061C3.88027 5.62007 3.88027 4.84095 4.3608 4.36041C4.79765 3.92355 5.48124 3.88384 5.96294 4.24126L6.10095 4.36041L11 9.25959L15.899 4.36041L16.037 4.24126Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDelete);
export default __webpack_public_path__ + "static/media/file-delete.fb517200dddd6d2dc64c28e8058fb478.svg";
export { ForwardRef as ReactComponent };